/* ============================================
   ANIMATE CONTENT ON SCROLL (MeshPlanet)
   Adds the .mp-in-view class to .mp-animate-content blocks when they scroll
   into view, triggering a fade-in + slide-up of their content (CSS handles
   the transition). One-shot: the class is added once and never removed.
   Performance: IntersectionObserver only; no scroll handler.
   ADDED: 2026-06-23 by MeshPlanet
   ============================================ */
(function () {
  'use strict';

  // Load/run only once even if injected by several blocks.
  if (window.__mpAnimContentInit) return;
  window.__mpAnimContentInit = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supported = 'IntersectionObserver' in window;

  var io = (!reduce && supported)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mp-in-view');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' })
    : null;

  function init() {
    var els = document.querySelectorAll('.mp-animate-content:not(.mp-in-view)');
    for (var i = 0; i < els.length; i++) {
      // No observer (reduced motion / old browser): just show the content.
      if (io) io.observe(els[i]);
      else els[i].classList.add('mp-in-view');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-scan when sections reload in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
